export default function validation(i18n, response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('ACOMPTE_AMOUNT_TOO_GREAT') === 0) {
      messages.push({
        message: 'validationAcompte.montantGreat',
      });
    }
    if (message.indexOf('REFUND_HIGHER_THAN_FACTURE') === 0) {
      messages.push({
        message: 'validationAvoir.refundGreaterThanFacture',
      });
    }
    if (message.indexOf('AVOIR_BILL_AMOUNT_NEGATIVE') === 0) {
      messages.push({
        message: 'validationAvoir.avoirBillAmountNegative',
      });
    }
    if (message.indexOf('LETTRAGE_FORBIDDEN_BETWEEN_AVOIR_AND_ACOMPTE') === 0) {
      messages.push({
        message: 'validationAcompte.avoirForbiddenAcompte',
      });
    }
    if (message.indexOf('ACOMPTE_MULTI_PAYER_FORBIDDEN') !== -1) {
      messages.push({
        message: 'validationAcompte.multiPayerForbidden',
      });
    }
    if (message.indexOf('SAVED_STATE_REQUIRED') === 0) {
      messages.push({
        message: 'validationAcompte.savedStateRRequired',
      });
    }
    if (message.indexOf('ACCOUNTING_ACCOUNT_REQUIRED') === 0) {
      messages.push({
        message: 'validationAcompte.accountingAccountRequired',
      });
    }
    if (message.indexOf('The TiersId field is required') !== -1) {
      messages.push({
        message: 'validationAcompte.tiers',
      });
    }
    if (message.indexOf('The ModeReglementId field is required') !== -1) {
      messages.push({
        message: 'validationAcompte.modeReglement',
      });
    }
    if (message.indexOf('ACOMPTE_SUM_AMOUNT_EXCEED_DEVISCOMMANDE_AMOUNT') !== -1) {
      messages.push({
        message: 'validationAcompte.sumMontantGreat',
      });
    }
    if (message.indexOf('AVOIR_AMOUNT_SHOULD_BE_DIFFERENT_ZERO') !== -1) {
      messages.push({
        message: 'validationAvoir.amountDiffZero',
      });
    }
    if (message.indexOf('PROSPECT_NOT_ALLOWED') !== -1) {
      messages.push({
        message: 'validationAcompte.prospectNotAllowed',
      });
    }
    if (message.indexOf('INVOICE_CODE_MUST_BE_REPLACED_FULLY') === 0) {
      const elements = message.split('|')[0].split('@');
      const codeCommande = elements[1];
      messages.push({
        message: 'validationAcompte.invoiceCodeMustBeReplacedFully',
        parametres: {
          param1: codeCommande,
        },
      });
    }
  });
}
